<template>
    <div class="wrapper">
      <div class="content-container">
        <div class="stingy-card">
          <h2>🎉 Hey Money-Smart Cats! 🎉</h2>
  
          <p>Wondering how your money's getting treated at your bank or investment firm? Here's a quick pounce into the nitty-gritty of Canadian Investor Protections! 🐾</p>
  
          <p>💰<b> CDIC - Canadian Deposit Insurance Corporation</b> 💰</p>
          <p>CDIC insures up to $100,000 per account type—like a savings or chequing account. That's a lot of treats and catnip!  CDIC provides an easy calculator to determine if your investments are covered and if your institution is part of CDIC which we've included below. Keep in mind too a lot of financial institutions where you buy GICs in your TFSA or RRSP are CDIC members so remember to ensure that they are. </p>
        
  
          <p>🛡<b> CIPF - Canadian Investor Protection Fund </b>🛡</p>
          <p>
            Investing with a CIPF member? Purr-fect! The CIPF ensures the return of your property up to $1 million if your investment firm becomes insolvent ...meaning bankruptcy of the firm itself.  This is rare but definitely does happen
            so make sure before you open an account you research if the firm is a registered company through CIRO and CIPF.  

            <br><br>Now let's get into an example, if you bought 100 shares of Company X at $50 each for a book value of $5000, and the value dropped to $30 when the firm went belly up, you'd be compensated for the 100 shares to receive back, usually by a transfer to another institution.    <br><br>This all takes quite a bit of time as the regulators need to work together to determine every investor's value on the date of bankruptcy so don't expect to actually get your money or investments back right away. This protection does not prevent you
            from the market prices moving up and down so by the time you get back your 100 shares of Company X they could be even lower (than $30) as that's a risk of investing.  You do at least get your 100 shares back though if the investment firm you are working with is a member of CIPF which all CIRO members are.   Think Lehman Brothers in the US (who was protected by SIPC) or MF Global Canada up here where CIPF made clients whole. In short, be a curious cat and do your research with the company you are investing with before you sign up.  If they are not a member of CIPF or CDIC avoid like water for a cat!
        
            <br><br>As of November 2023, crypto assets are NOT covered at all by any CIRO and CIPF covered firm so please extra careful when investing.  
        
        </p>
          
  
          <p>🕵️ <b>OBSI - Ombudsman for Banking Services and Investments</b> 🕵️</p>
          <p>Got a complaint? OBSI's the cat's meow for resolving issues between you and your financial institution. This can include things like deposits, mortgages or anything you use their services for.  They've been doing it for 27 years! How many cat lives is that? 😹 Also important to note is that
            if you went through your CIRO complaint process and are still not satisfied OBSI may be able to help.
          </p>
    
  
          <p><b>
            StingyCat Hot Tip 🐾</b>: Only work with a registered firm. Regardless if you decide to work with an investment advisor or some random firm you saw an ad for on social media make sure they are licensed and review their background.  The best part about the investment industry is all of the information is out there and publicly available at your paws...it's your responsibility to do your due diligence.  <br><br>You wouldn't take a nap in a random alley, right? Just like us cats we pick our people only approaching humans that make us feel safe so do the same with your investment firm, your advisor and your investments.  Life is too short to lose your treats!
        
          </p>

          <h3>😾 How to Hiss...err...Complain 😾</h3>
          <img :src="require('@/assets/cat-pissed.gif')" alt="Cat Confetti" width="200" height="200" />
<p>✅ Check Your Advisor: Are they a CIRO Member? Confirm it! Also check if they have any terms and conditions.</p>
<p>✅ Gather Your Facts: Document everything, like a cat stalking its prey.</p>
<p>✅ Talk to your Investment Firm's Supervisor: When it comes to your money it's OK to be a Karen but always remember that starting with cuddles rather than hisses can usually solve a problem easily. A lot of times it can be a misunderstanding!  Just like cats, we are all emotional and there is no more emotional feeling (besides cats) than your own hard-earned money. </p>
<p>✅ File Your Complaint (if you are still not happy): Write it down, make it formal, like a cat in a bowtie. </p>
<p>✅ Still Scratching Your Head? If you're not happy, you can escalate things to the OBSI. Free of charge, like a good belly rub!</p>

<h3>No Kittening Around: Investor Recourse & Compensation</h3>
<p>✅ Not happy with the response? Got your tail in a twist? OBSI can recommend compensation up to $350,000—imagine how much catnip that could buy!</p><br>

        </div>
          <div class="stylish-links">
          <h3>🔗 Important Links 🖇️</h3>
          <ul>
            <li><a href="https://www.cdic.ca/calculator/dashboard/select-category" target="_blank">CDIC - Calculate your Coverage</a></li>
            <li><a href="https://www.iiroc.ca/advisor-report-search" target="_blank">CIRO (Formerly IIROC) Advisor Report Search</a></li>
            <li><a href="https://www.ciro.ca/office-investor/how-make-complaint" target="_blank">CIRO's Complaint Process</a></li>
            <li><a href="https://consumerportal.obsi.ca/public/inquiries/inquiry" target="_blank">OBSI's Consumer Portal for making a complaint</a></li>
            
          </ul>
        </div>

         
      </div>
    </div><br><br><br><br><br><br>
  </template>
  

<script>
</script>



<style scoped>
.wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.content-container {
  background-color: #4A148C ;  
  color: black;
  padding: 20px;
  border-radius: 20px;  /* Adjust this value to your preference */
  overflow: hidden; 
}
.stingy-card {
    flex: 1;  /* Take up equal width as the iframe */
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  background-color: white
}

.stylish-links {
  background: linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(240,240,240,1) 100%);
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
}

.stylish-links h3 {
  color: #333;
  font-size: 1.4em;
  margin-bottom: 15px;
}

.stylish-links ul {
  list-style: none;
  padding: 0;
}

.stylish-links ul li {
    background-image: linear-gradient(135deg, #6D5BBA 0%, #8D58BF 100%); /* Apply the same gradient as your app theme */
  color: white;
  border: none;
  padding: 10px 15px;
  border-radius: 5px;
  margin: 5px;
  cursor: pointer;
  transition: background-color 0.3s, box-shadow 0.3s;
  }
  
  .stylish-links ul li a {
    color: white;
    text-decoration: none;
    font-weight: bold;
  }
  
  .stylish-links ul li:hover {
    background-image: linear-gradient(135deg, #8D58BF 0%, #6D5BBA 100%); /* Slightly adjust gradient for hover effect */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2); /* Add a shadow for depth */
  }
  
  .stylish-links ul li:hover a {
    color: #fff;
  }
</style>